export function uniqueID() {
    const date = new Date();
    const components = [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
    ].join("")

    const firstPart = Math.floor(Math.random() * parseInt(components))
    const secPart = Math.floor(Math.random() * parseInt(components))

    const components2 = [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ].join("");

    const thirdPart = Math.floor(Math.random() * parseInt(components2))

    const uuid = `${firstPart}-${components2}-${secPart}-${thirdPart}`;
    return uuid;
}
